/**
 * @param {GeneratedSummary?} generatedSummary
 */
export default function parseGeneratedSummary(generatedSummary) {
  if (!generatedSummary?.summary) return null;

  if (generatedSummary.detail === 'BULLET_FORMAT_SUMMARY') {
    return {
      ...generatedSummary,
      summary: generatedSummary.summary.replaceAll('* ', '').split('\n'),
    };
  }
  return generatedSummary;
}
